import { Context, createContext, useContext } from 'react';
import { GTMEventTrackerService } from './google-tag-manager';
import { Tracker } from './model';

export const analyticsTracker: Tracker = new GTMEventTrackerService();
export const EventTrackerContext: Context<Tracker> = createContext<Tracker>(analyticsTracker);

export const useAnalyticsTracker = (): Tracker => useContext(EventTrackerContext);
